const eventsSelect = $('.events-select-month #month-select');
if (eventsSelect.length > 0) {

    let mqForRefreshSelect = window.matchMedia('(min-width: 768px)');
    $(window).on('resize orientationchange', function () {
        if (!mqForRefreshSelect.matches) refreshStyler();
    });

    let listMonths = {
        'January': 0,
        'February': 1,
        'March': 2,
        'April': 3,
        'May': 4,
        'June': 5,
        'July': 6,
        'August': 7,
        'September': 8,
        'October': 9,
        'November': 10,
        'December': 11,
    };

    eventsSelect.on('change', function () {
        let value = $(this).val() ?? 'All';
        let eventsItemList = $('.events-list').find('.events-list-item[data-month]');
        let eventsHeadList = $('.events-list').find('.events-list-month[data-month]');
        let eventSelectMonth = $('.events-list-month-select');

        if (value === 'All') {
            eventSelectMonth.find('h2').text('');
            eventSelectMonth.addClass('dn');
        } else {
            let valueListForHead = value.split(' ');
            eventSelectMonth.find('h2').text(`${valueListForHead[0]}, ${valueListForHead[1]}`);
            eventSelectMonth.removeClass('dn');
        }

        eventsHeadList.each(function () {
            (value === 'All') ? $(this).removeClass('dn') : $(this).addClass('dn');
        });

        eventsItemList.each(function () {
            let _thatEvent = $(this);
            let isActive = true;
            if (value === 'All') {
                _thatEvent.removeClass('dn');
            } else {
                let datesList = _thatEvent.attr('data-month').split('-');
                if (datesList.length === 1) {
                    isActive = value === _thatEvent.attr('data-month');
                    isActive ? _thatEvent.removeClass('dn') : _thatEvent.addClass('dn');
                } else {
                    let valueList = value.split(' ');
                    let valueDateStart = new Date(valueList[1], listMonths[valueList[0]], 1);

                    let eventStart = datesList[0].split(' ');
                    let eventEnd = datesList[1].split(' ');
                    let eventDateStart = new Date(eventStart[1], listMonths[eventStart[0]], 1);
                    let eventDateEnd = new Date(eventEnd[1], listMonths[eventEnd[0]], 1);

                    isActive = valueDateStart >= eventDateStart && valueDateStart <= eventDateEnd;
                    isActive ? _thatEvent.removeClass('dn') : _thatEvent.addClass('dn');
                }
            }
        });
    });
}
